module.exports = __webpack_public_path__ + "img/top_layout.e796938e.svg";